import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import bgImage from "../assets/constrHero.jpg";

const cardVariant = {
    
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.6, ease: "easeOut" },
  }),
};



function ProjectPreview() {
  const navigate = useNavigate();
  const ref = useRef();
  const isInView = useInView(ref, { once: false, threshold: 0.3 });

  return (
    <motion.section
      ref={ref}
      className="relative w-full h-auto bg-cover bg-center"
      style={{ backgroundImage: `url(${bgImage})` }}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50" />

      <div className="max-w-6xl mx-auto items-center my-12 relative z-10 px-4">
        {/* Overlapping Cards (Hidden on small screens) */}
        <div className="hidden sm:flex absolute -top-28 left-1/2 transform -translate-x-1/2 z-20 gap-0">
          {/* Card 1 */}
          <motion.div
            custom={0}
            variants={cardVariant}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            className="w-60 h-40 bg-orange-300 shadow-lg rounded-xl p-4"
          >
            <h3 className="text-sm sm:text-lg md:text-xl lg:text-2xl font-semibold mb-2">Quick Service</h3>
            <p className="text-gray-800 pt-6 text-sm">
              Always ready for rapid response and technical support.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div
            custom={1}
            variants={cardVariant}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            className="w-[45rem] h-40 bg-gray-950 shadow-lg rounded-xl p-4 flex divide-x divide-gray-300"
          >
            <div className="flex-1 px-4">
              <h4 className="text-sm sm:text-lg md:text-xl lg:text-2xl font-semibold text-gray-300 mb-1">
                Consulting
              </h4>
              <p className="text-sm text-gray-300 pt-6">
                Strategic insights and planning for your ICT, IoT, and
                infrastructure projects.
              </p>
            </div>

            <div className="flex-1 px-4">
              <h4 className="text-sm sm:text-lg md:text-xl lg:text-2xl font-semibold mb-1 text-gray-300">
                Implementation
              </h4>
              <p className="text-sm text-gray-300 pt-6">
                Full setup of integrated smart systems and networks.
              </p>
            </div>

            <div className="flex-1 px-4">
              <h4 className="text-sm sm:text-lg md:text-xl lg:text-2xl font-semibold mb-1 text-gray-300">
                Maintenance
              </h4>
              <p className="text-sm text-gray-300 pt-6">
                Routine checks and on-demand fixes to keep your systems running.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Text Section */}
        <motion.div
          custom={2}
          variants={cardVariant}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="relative z-30 flex justify-start items-center h-full pt-24 pb-5"
        >
          <div className="max-w-xl text-left px-4 text-white">
            <p className="text-orange-400 font-semibold mb-2">
              Your Trusted Partner
            </p>
            <p className="mb-6 font-bold sm:text-lg md:text-xl leading-relaxed">
              We specialize in delivering high-impact, scalable solutions.
              Whether you're starting from scratch or upgrading your systems,
              our expert team ensures reliable execution from planning to
              maintenance.
            </p>
            <div className="flex justify-start gap-4 mb-5 flex-wrap">
              <button onClick={() => navigate("/contact")}  className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-2 rounded-xl transition duration-300">
                Get Started
              </button>
              <button onClick={() => navigate("/quote")} className="border border-white text-white font-semibold px-6 py-2 rounded-xl hover:bg-white hover:text-black transition duration-300">
                request quote
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
}

export default ProjectPreview;
